import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import { getTrade } from "../../utils/contractHelpers";
import { useRecoilValue } from "recoil";
import { userSmartAccount } from "../../components/RecoilAtom";
import { convertFromWeiEthers } from "../../utils/helpers";

const useClaimRewards = () => {
    const smartAccount = useRecoilValue(userSmartAccount)
    const web3 = useWeb3();

    const getCreatorReward = async (contract, tokenDecimals) => {
        try {
            const creatorRewards = await contract.methods.getCreatorReward().call();
            const creatorReward = Number(convertFromWeiEthers(creatorRewards, tokenDecimals));
            return creatorReward;
        } catch (error) {
            console.log("error in getCreatorReward", error);
        }
    }

    const getLiquidityReward = async (contract, tokenDecimals) => {
        try {
            const liquidityRewards = await contract.methods.getLiquidityReward(smartAccount).call();
            const liquidityReward = Number(convertFromWeiEthers(liquidityRewards, tokenDecimals));
            return liquidityReward;
        } catch (error) {
            console.log("error in liquidityReward", error);
        }
    }

    const getResolverReward = async (contract, tokenDecimals) => {
        try {
            const resolverRewards = await contract.methods.getResolverReward().call();
            const resolverReward = Number(convertFromWeiEthers(resolverRewards, tokenDecimals));
            return resolverReward;
        } catch (error) {
            console.log("error in getResolverReward", error);
        }
    }

    const getSharesReward = async (contract, tokenDecimals, winnerOptionIndex) => {
        try {
            const shareRewards = await contract.methods.getSharesReward(smartAccount, winnerOptionIndex).call();
            const shareReward = Number(convertFromWeiEthers(shareRewards, tokenDecimals));
            return shareReward;
        } catch (error) {
            console.log("error in getSharesReward but calling userVotes", error);
            // this is something which is only done because of the resolution of some v3 pools as soon as those pools are resolved this will be removed
            const userVotes = await contract.methods.userVotes(winnerOptionIndex, smartAccount).call();
            const userVotess = Number(convertFromWeiEthers(userVotes, tokenDecimals));
            return userVotess;
            // 
        }
    }

    const getResolutionProposer = async (contract) => {
        try {
            const resolverAddress = await contract.methods.resolutionProposer().call();
            return resolverAddress;
        } catch (error) {
            console.log("error in getResolutionProposer", error);
        }
    }

    const getResolverBondData = async (contract, tokenDecimals) => {
        try {
            const resolverBondAmount = await contract.methods.getResolverBondAmount().call();
            const resolverBondReward = Number(convertFromWeiEthers(resolverBondAmount, tokenDecimals));
            return resolverBondReward;
        } catch (error) {
            console.log("error in getResolverBondData", error);
        }
    }

    const getDisputerInfo = async (contract, tokenDecimals) => {
        try {
            const disputerData = await contract.methods.dispute().call();
            const disputeRefunds = Number(convertFromWeiEthers(disputerData?.disputeFee, tokenDecimals));
            const disputerAddress = disputerData?.disputer;
            const disputedWinner = disputerData?.disputedWinner
            return { disputeRefunds, disputerAddress, disputedWinner };
        } catch (error) {
            console.log("error in getDisputerInfo", error);
        }
    }

    const getAppealerInfo = async (contract, tokenDecimals) => {
        try {
            const appealerData = await contract.methods.appeal().call();
            const appealRefunds = Number(convertFromWeiEthers(appealerData?.disputeFee, tokenDecimals));
            const AppealerAddress = appealerData?.disputer;
            const appealedWinner = appealerData?.disputedWinner
            return { appealRefunds, AppealerAddress, appealedWinner };
        } catch (error) {
            console.log("error in getAppealerInfo", error);
        }
    }

    const getUserClaimRewards = useCallback(
        async (address, tokenDecimals, poolOwnerWalletAddress, choiceIndex) => {
            const contract = getTrade(address, web3);
            try {

                // const disputerData = await getDisputerInfo(contract, tokenDecimals);
                // const appealerData = await getAppealerInfo(contract, tokenDecimals);
                // const resolverBondAmount = await getResolverBondData(contract, tokenDecimals);

                // const creatorReward = await getCreatorReward(contract, tokenDecimals);
                // const liquidityReward = await getLiquidityReward(contract, tokenDecimals);
                // const resolverReward = await getResolverReward(contract, tokenDecimals);
                const shareReward = await getSharesReward(contract, tokenDecimals, choiceIndex);
                // const resolverAddress = await getResolutionProposer(contract);

                const eligibleRewards = {};

                // if (
                //     poolOwnerWalletAddress?.toLowerCase() ===
                //     smartAccount?.toLowerCase()
                // ) {
                //     eligibleRewards.creatorReward = creatorReward;
                // }

                // if (liquidityReward > 0) {
                //     eligibleRewards.liquidityReward = liquidityReward;
                // }

                // if (
                //     resolverAddress?.toLowerCase() ===
                //     smartAccount?.toLowerCase()
                // ) {
                //     eligibleRewards.resolverReward = resolverReward;
                //     eligibleRewards.resolverBondAmount = resolverBondAmount;
                // }

                // if (
                //     disputerData?.disputerAddress?.toLowerCase() ===
                //     smartAccount?.toLowerCase() && +disputerData?.disputedWinner != +choiceIndex
                // ) {
                //     eligibleRewards.disputeRefunds = disputerData?.disputeRefunds;
                // }

                // if (
                //     appealerData?.AppealerAddress?.toLowerCase() ===
                //     smartAccount?.toLowerCase() && +appealerData?.appealedWinner != +choiceIndex
                // ) {
                //     eligibleRewards.appealRefunds = appealerData?.appealRefunds;
                // }

                if (shareReward > 0) {
                    eligibleRewards.shareReward = shareReward;
                }

                const totalClaimable = Object.values(eligibleRewards)
                    .reduce((sum, value) => sum + value, 0);

                return {
                    eligibleRewards,
                    totalClaimable,
                };
            } catch (error) {
                console.error("Error fetching claimable rewards:", error.message || error);
                throw error;
            }
        },
        [web3, smartAccount]
    );

    return { getUserClaimRewards };
};

export default useClaimRewards;
